<div class="header-modal-container" [class.show]="isVisible" (click)="closeModal()">
  <div class="header-modal-container-background" [class.show]="isVisible">
    <div class="header-modal-container-background-workspace" [class.show]="isVisible" (click)="$event.stopPropagation()">
      <div class="header-modal-container-background-workspace-icon">
        <app-icon [icon]="Icons.crossClose" (click)="closeModal()"/>
      </div>
      <div class="header-modal-container-background-workspace-content">
        <div class="header-modal-container-background-workspace-content-label">
          {{ languageService.translate(['SHOPPING BAG', 'КОРЗИНА']) }}
        </div>
        <div class="cart-content">
          <div class="cart-items" *ngIf="booking.cartServices().length > 0">
            <div class="cart-item" *ngFor="let service of booking.cartServices()">
              <div class="cart-item-info">
                <div class="cart-item-title">{{ service.title }}</div>

                <div class="cart-item-details">
                  {{ getServiceAirportLine(service) }}
                </div>

                <div
                  class="cart-item-details"
                  *ngIf="getServiceFlightNumber(service)"
                >
                  {{ languageService.translate(['Flight:', 'Рейс:']) }}
                  {{ getServiceFlightNumber(service) }}
                </div>

                <div class="cart-item-details">
                  {{ getServiceDateTimeLine(service) }}
                </div>

                <div class="cart-item-details">
                  {{ getServiceRoleText(service) }}
                </div>
              </div>
              <div class="cart-item-price">
                {{ currencyService.formatPrice(getServicePrice(service)) }}
              </div>
            </div>
          </div>

          <div class="divider"></div>
          <div class="total">
            <span class="total-label">{{ languageService.translate(['Total', 'Итого']) }}</span>
            <span class="total-price">{{ currencyService.formatPrice(getTotal()) }}</span>
          </div>
          <div class="actions">
            <button class="btn-checkout" (click)="goToCheckout()">
              {{ languageService.translate(['Continue to checkout', 'Перейти к оплате']) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
